import { Expand } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogTitle, DialogTrigger } from "@/components/ui/dialog";

const IMAGES = {
  journey: {
    src: "/images/pbl-inquiry-journey.webp?v=2",
    sm: "/images/pbl-inquiry-journey-960.webp?v=2",
    title: "PBL & Inquiry Learning journey",
    alt: "PBL and Inquiry Learning: our five-step learning journey — a real question, inquiry and research, explore and create ideas, plan and take action, share and reflect.",
  },
  map: {
    src: "/images/knowledge-map.webp?v=3",
    sm: "/images/knowledge-map-960.webp?v=3",
    title: "Build Your Knowledge Map",
    alt: "Build Your Knowledge Map: real-world projects connect Science, Engineering, Social Studies & Humanities and Critical Thinking, with a six-step example from a real-world question to a growing knowledge map.",
  },
};

export const JourneyImage = ({ name = "journey", priority = false, testid = "pbl-journey-image", className = "max-w-[1000px]" }) => {
  const img = IMAGES[name];
  return (
    <div className={`relative mx-auto w-full ${className}`}>
      <Dialog>
        <DialogTrigger asChild>
          <button
            type="button"
            className="group relative block w-full overflow-hidden rounded-[32px] border border-ink/10 bg-white shadow-soft"
            aria-label={`Open the ${img.title} image in full size`}
            data-testid={testid}
          >
            <img src={img.sm} srcSet={`${img.sm} 960w, ${img.src} 1536w`} sizes="(min-width: 1024px) 900px, 100vw"
              alt={img.alt} width="1536" height="1024" loading={priority ? "eager" : "lazy"} fetchPriority={priority ? "high" : "auto"}
              className="block h-auto w-full transition-transform duration-500 group-hover:scale-[1.02]" />
            <span className="absolute bottom-2 right-2 inline-flex items-center gap-1.5 rounded-full border border-ink/10 bg-white p-2 text-sm font-bold sm:bottom-3 sm:right-3 sm:px-3 sm:py-1.5">
              <Expand className="h-4 w-4" aria-hidden="true" /> <span className="hidden sm:inline">View full size</span>
            </span>
          </button>
        </DialogTrigger>
        <DialogContent className="w-auto max-w-[96vw] rounded-[28px] border border-ink/10 bg-cream p-3 sm:p-4" data-testid={`${testid}-dialog`}>
          <DialogTitle className="sr-only">{img.title}</DialogTitle>
          <DialogDescription className="sr-only">{img.alt}</DialogDescription>
          <img src={img.src} alt={img.alt} width="1536" height="1024" className="mx-auto h-auto max-h-[85vh] w-auto max-w-full rounded-[20px] object-contain" />
        </DialogContent>
      </Dialog>
    </div>
  );
};
